import React, { useState } from "react";
import { BsTrash3 } from "react-icons/bs";
import DeleteAccountModal from "../modals/DeleteAccountModal";
import "./DeleteAccountButton.css";

export default function DeleteAccountButton() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button className="delete-account-btn" onClick={() => setShowModal(true)}>
        <BsTrash3 className="delete-icon" size={18} />
        Apagar Conta
      </button>

      {showModal && (
        <DeleteAccountModal onClose={() => setShowModal(false)} />
      )}
    </>
  );
}
